import React from 'react';
import { trackingFavoritesIconClick } from './tracking';
import { Favorites as FavoritesIcon } from '../Icons/Favorites';
import { Icon } from '../GroupIcons/Icon';
import { FavoritesModal } from '../FavoritesModal/FavoritesModal';
import { IFavoriteEntityForDesktopSchema } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import {
  EEntityTypes,
  EOrderField,
  IWebGetUserFavoritesRequest,
  IWebGetUserFavoritesResponse,
} from '../../repositories/favorites/v1/web-get-user-favorites';

interface IFavorites {
  favLink: string;
  getFavorites?(params: IWebGetUserFavoritesRequest): Promise<IWebGetUserFavoritesResponse | null>;
}

const FAVORITES_PATH = 'favorites';

export const Favorites: React.FC<IFavorites> = ({ favLink, getFavorites }) => {
  const [isFavoritesModalOpen, setIsFavoritesOpenModal] = React.useState<boolean>(false);
  const [favoriteEntities, setFavoriteEntities] = React.useState<IFavoriteEntityForDesktopSchema[]>([]);
  const [canLoadMore, setCanLoadMore] = React.useState(false);
  const [entityTypes, setEntityType] = React.useState<EEntityTypes.Newbuilding | null>(null);
  const [offset, setOffset] = React.useState<number>(0);
  const [isFetching, setIsFetching] = React.useState<boolean>(true);

  const fetchFavorites = React.useCallback(async () => {
    if (getFavorites) {
      const types = entityTypes
        ? [entityTypes]
        : [EEntityTypes.Commercial, EEntityTypes.Residential, EEntityTypes.Suburban];

      const result = await getFavorites({
        orderField: EOrderField.Added,
        entityTypes: types,
        offset,
      });

      if (result) {
        setFavoriteEntities(offset > 0 ? [...favoriteEntities, ...result.favoriteEntities] : result.favoriteEntities);
        setCanLoadMore(result.canLoadMore);
        setIsFetching(false);
      } else {
        setFavoriteEntities(favoriteEntities.length ? favoriteEntities : []);
        setIsFetching(false);
      }
    }
  }, [isFavoritesModalOpen, entityTypes, offset]);

  React.useEffect(() => {
    if (isFavoritesModalOpen) {
      fetchFavorites();
    }
  }, [isFavoritesModalOpen, entityTypes, offset]);

  const openFavoritesModal = () => {
    setIsFavoritesOpenModal(true);
    trackingFavoritesIconClick();
  };

  const closeFavoritesModal = () => {
    setIsFavoritesOpenModal(false);
  };

  const changeEntityType = (type: EEntityTypes.Newbuilding | null) => {
    setEntityType(type);
    setOffset(0);
    setIsFetching(true);
  };

  const updateFavoritesList = (length: number) => {
    setOffset(length);
  };

  return (
    <>
      <Icon disableHref notifications={0} onClick={openFavoritesModal} iconView={<FavoritesIcon />} title="" />
      {isFavoritesModalOpen && (
        <FavoritesModal
          isFavoritesPage={window.location.pathname.includes(FAVORITES_PATH)}
          favLink={favLink}
          isFetching={isFetching}
          canLoadMore={canLoadMore}
          entityTypes={entityTypes}
          favoriteEntities={favoriteEntities}
          updateFavoritesList={updateFavoritesList}
          changeEntityType={changeEntityType}
          closeFavoritesModal={closeFavoritesModal}
        />
      )}
    </>
  );
};
